export default {
  title: 'Diversidad de Servicios',
  carousel :{
    T1:'Firma con',
    P1:'más de 25 años de experiencia',
    T2:'Entendemos el negocio de cada uno de nuestros clientes',
    P2:'Abordamos con visión estratégica los desafíos de cada compañía.',
    T3:'Nuestra firma es miembro de:',
    P3:'PrimeGlobal es una de las 5 asociaciones más grandes de firmas de contadores independientes en el mundo, compuesta por aproximadamente 286 firmas de contadores públicos independientes de gran éxito en más de 88 países. Las firmas miembro independientes de PrimeGlobal albergan un total combinado de más de 2,338 socios, 22,567 empleados.',
    SP3: 'PrimeGlobal se encuentra en todo el mundo, dividido en 4 regiones: Asia Pacífico, Europa, Medio Oriente y África, América Latina, América del Norte.'
  },
  globes:[
    {
      title: 'Países',
      data: '90',
      image: require('@/assets/iconos/countries.png')
    },
    {
      title: 'Empresas',
      data: '288',
      image: require('@/assets/iconos/firms.png')
    },
    {
      title: 'Oficinas',
      data: '852',
      image: require('@/assets/iconos/offices.png')
    },
    {
      title: 'Ingresos',
      data: '$2.93 BILLONES',
      image: require('@/assets/iconos/revenue.png')
    },
    {
      title: 'Satisfacción de miembros',
      data: '86%',
      image: require('@/assets/iconos/member.png')
    },
    {
      title: 'Personal / Socios',
      data: '26,270',
      image: require('@/assets/iconos/staff.png')
    }
  ],
  principles: {
    title: 'Principios y valores guían nuestras acciones',
    description: 'De tal manera promovemos que nuestros profesionales desarrollen su labor con integridad y pasión por la excelencia y la disciplina de informar de manera oportuna.'
  },
  mission: 'Somos una firma guatemalteca con más de 25 años de experiencia, cuya misión es atender las necesidades de nuestros clientes, proporcionándoles un servicio de altos estándares de calidad y compromiso por medio de nuestro personal con altas competencias profesionales.',
  vision: 'Ser una firma líder en el mercado que pueda brindar oportunidad de empleo a más guatemaltecos y sea reconocida por crear una base sólida de confianza a nuestros clientes.',
  values: [
    {
      title : 'Integridad',
      description : 'Es el principal valor que resalta nuestra firma y nuestro equipo de trabajo. Actuamos de forma correcta en las diferentes situaciones en que nos presentemos de acuerdo a las normas, estatutos y controles de calidad que tenemos establecidos.',
    },
    {
      title : 'Pasión por la excelencia',
      description : 'Somos profesionales que amamos lo que hacemos y buscamos siempre alcanzar la excelencia en nuestros resultados con los clientes. Nos entregamos y nos enfocamos en nuestra labor para cumplir con entera satisfacción los requerimientos de nuestros clientes.',
    },
    {
      title : 'Disciplina',
      description : 'Nos caracterizamos por nuestro alto grado de compromiso a seguir los diferentes modelos de conducta que rigen la firma para alcanzar el desarrollo efectivo de nuestras habilidades y potencial.'
    },
    {
      title : 'Transparencia',
      description : 'Somos totalmente transparentes en nuestro trabajo, nuestros resultados y nuestro comportamiento. Nos mostramos con total transparencia ante nuestros clientes y nuevas oportunidades de negocios.',
    },
    {
      title : 'Empatía',
      description : 'Tenemos la habilidad de ponernos en los zapatos del otro, entendemos las necesidades de nuestros clientes, nuestras autoridades y nuestros compañeros.',
    },
    {
      title : 'Respeto',
      description : 'Fomentamos altamente el respeto como un valor que nos permita convivir en armonía.',
    }
  ],
  images:[
    {
      title: 'Asesoría y Consultoría',
      img: require('@/assets/iconos/ico_4.svg')
    },
    {
      title: 'Auditoría',
      img: require('@/assets/iconos/ico_5.svg')
    },
    {
      title: 'Traducción Jurada',
      img: require('@/assets/iconos/ico_6.svg')
    },
    {
      title: 'Seminarios',
      img: require('@/assets/iconos/ico_7.svg')
    },
    {
      title: 'Reclutamiento',
      img: require('@/assets/iconos/ico_8.svg')
    },
    {
      title: 'Outsourcing',
      img: require('@/assets/iconos/ico_9.svg')
    },
    {
      title: 'Tecnología y Sistemas',
      img: require('@/assets/iconos/ico_10.svg')
    },
    {
      title: 'Impuestos y Legal',
      img: require('@/assets/iconos/ico_11.svg')
    }
  ],
  control: {
    title:'Control de Calidad',
    description : 'Trabajamos con estrictos estándares de calidad y rigurosidad, que nos permiten optimizar la gestión de riesgos, preservar el negocio y aportar a la construcción de negocios confiables.'
  },
  confidentiality: {
    title: 'Confidencialidad',
    description : 'Entendemos y comprendemos que el brindar información intima de la(s) compañía(s) conlleva determinada responsabilidad, principalmente por la Ética Profesional de nuestra firma y nuestros profesionales.',
    subdescription : 'Estamos en la total disposición de respetar y basarnos en los procedimientos internos de nuestros clientes en cuanto a confidencialidad.',
  }
}



// WEBPACK FOOTER //
// ./src/text/es/home.js